import React from 'react';

import {
  useIsUpdating,
  useReviews,
} from 'scenes/Gallery/GalleryPage/Creatives/Reviews/data';
import { ReviewsSummary } from 'scenes/Gallery/components/Reviews';

const CreativeReviewsSummary = ({ creativeId, rating }) => {
  const { data, isLoading } = useReviews(creativeId);

  const isUpdating = useIsUpdating();

  return (
    <ReviewsSummary
      rating={rating}
      data={data}
      isLoading={isLoading || isUpdating}
    />
  );
};

export default CreativeReviewsSummary;
